import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface HereAccount {
  accessToken: string
  birthdate: string
  countryCode: string
  email: string
  expires: number
  family_name: string
  given_name: string
  language: string
  locale: string
  name: string
  sub: string
}

export const OIDC_STATE_PROPERTIES = ['action', 'error', 'hash', 'pathName', 'search'] as const
type OidcKeyNames = typeof OIDC_STATE_PROPERTIES
type HAActionName = 'sign-in' | 'sign-up'
export type HAActionPayload = {
  action: HAActionName
}
export type OidcStateKey = OidcKeyNames[number]
type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>
export type OidcState = Optional<Record<OidcStateKey, string>, 'error'>

export interface State {
  oidcState: OidcState
  nextRefresh?: number
  user?: HereAccount
}

export const DEFAULT_OIDC_STATE = { action: '', error: '', hash: '', pathName: '', search: '' }

const initialState: State = {
  oidcState: { ...DEFAULT_OIDC_STATE },
}

const slice = createSlice({
  initialState,
  name: 'account',
  reducers: {
    handleError(state: State, _: PayloadAction<string>) {
      return state
    },
    handleToken(state: State, _: PayloadAction<string>) {
      return state
    },
    removeUser(state: State, _: PayloadAction) {
      state.user = undefined
      return state
    },
    setOidcState(state: State, action: PayloadAction<OidcState>) {
      state.oidcState = action.payload
      return state
    },
    setUser(state: State, action: PayloadAction<HereAccount>) {
      state.user = action.payload
      return state
    },
    signIn(state: State, _: PayloadAction<OidcState & HAActionPayload>) {
      return state
    },
    signOut(state: State, _: PayloadAction) {
      return state
    },
    signUp(state: State, _: PayloadAction<OidcState & HAActionPayload>) {
      return state
    },
  },
})

export const {
  handleError,
  handleToken,
  removeUser,
  setOidcState,
  setUser,
  signIn,
  signOut,
  signUp,
} = slice.actions
export const reducer = slice.reducer
